export default "__VITE_ASSET__cN71G0cF__"